var _circle, _circle2, _circle3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgVerticalPoints = function SvgVerticalPoints(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 841.889 595.281"
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 420.945,
    cy: 297.64,
    r: 74.41
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 420.945,
    cy: 520.871,
    r: 74.41
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 420.945,
    cy: 74.41,
    r: 74.41
  })));
};

export default SvgVerticalPoints;